export { default, getServerSideProps } from "pages/[lang]/success-stories";
